<template>
  <el-form ref="form" :model="curInput.time" :rules="rules" label-width="100px">
    <el-form-item label="时间类型" prop="type">
      <el-select v-model="curInput.time.select_type" placeholder="请选择时间类型" class="h-40 w-200">
        <el-option v-for="item in timeType" :label="item.name" :value="item.id"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="是否选择范围" prop="range_status">
      <el-radio-group v-model="curInput.time.range_status">
        <el-radio :label="1" :disabled="typeFixed">是</el-radio>
        <el-radio :label="0" :disabled="typeFixed">否</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="是否固定时间间隔" prop="fixed_step" v-if="typeFixed">
      <el-radio-group v-model="curInput.time.fixed_step">
        <el-radio :label="TIME_FIXED_STEP_TRUE">是</el-radio>
        <el-radio :label="TIME_FIXED_STEP_FALSE">否</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="固定时间间隔" prop="time_step" v-if="typeFixed && isFixedStep">
      <el-input v-model.trim="curInput.time.time_step" placeholder="请填写时间间隔" class="h-40 w-200" @blur="setTimeSelectOptions"></el-input>
      <div class="form-tips">格式：HH:mm（HH代表时，mm代表分），默认值为00:01</div>
    </el-form-item>
    <el-form-item label="可选最小值" prop="time_min" v-if="!(typeFixed && !isFixedStep)">
      <el-radio-group v-model="curInput.time.time_min.type">
        <el-radio :label="item.id" v-for="item in limitType">{{ item.name }}</el-radio>
      </el-radio-group>
      <div v-if="minTypeVar">
        <el-input v-model.trim="curInput.time.time_min.var_limit" class="h-40 w-200" placeholder="请填写变量限制"></el-input>
      </div>
      <div v-if="minTypeFixed && (isFixedStep || !typeFixed) && pickerShow">
        <el-time-picker v-model="curInput.time.time_min.fixed_value" :format="format" placeholder="选择可选最小值"></el-time-picker>
      </div>
    </el-form-item>
    <el-form-item label="可选最大值" prop="time_max" v-if="!(typeFixed && !isFixedStep)">
      <el-radio-group v-model="curInput.time.time_max.type">
        <el-radio :label="item.id" v-for="item in limitType">{{ item.name }}</el-radio>
      </el-radio-group>
      <div v-if="maxTypeVar">
        <el-input v-model.trim="curInput.time.time_max.var_limit" class="h-40 w-200" placeholder="请填写变量限制"></el-input>
      </div>
      <div v-if="maxTypeFixed && (isFixedStep || !typeFixed) && pickerShow">
        <el-time-picker v-model="curInput.time.time_max.fixed_value" :format="format" placeholder="选择可选最大值"></el-time-picker>
      </div>
    </el-form-item>
    <el-form-item label="默认值" prop="default_type">
      <el-radio-group v-model="curInput.time.time_default.default_type">
        <el-radio :label="item.id" v-for="item in defaultType" :disabled="item.id == 20 && curInput.time.select_type == TIME_FIXED && curInput.time.fixed_step == 0">{{ item.name }}</el-radio>
      </el-radio-group>
      <!-- 变量限制+单时间默认值 -->
      <div v-if="defaultTypeVar && !isRange">
        <el-input v-model.trim="curInput.time.time_default.single" placeholder="请填写公式" class="h-40 w-200"></el-input>
      </div>
      <!-- 变量限制+单时间默认值 -->
      <!-- 变量限制+范围默认值 -->
      <div v-if="defaultTypeVar && isRange">
        <el-input v-model.trim="curInput.time.time_default.range_start" placeholder="请填写起始时间公式" class="h-40 w-200"></el-input>
        <br>
        <el-input v-model.trim="curInput.time.time_default.range_end" placeholder="请填写结束时间公式" class="h-40 w-200"></el-input>
      </div>
      <!-- 变量限制+范围默认值 -->
      <!-- 任意时间+固定值+单个时间默认值 -->
      <div v-if="typeAnyTime && defaultTypeFixed && !isRange">
        <el-time-picker v-model="curInput.time.time_default.fixed_value" :picker-options="timePickerOptions" placeholder="选择默认值"></el-time-picker>
      </div>
      <!-- 任意时间+固定值单个时间默认值 -->
      <!-- 任意时间+固定值时间范围默认值 -->
      <div v-if="typeAnyTime && defaultTypeFixed && isRange">
        <el-time-picker v-model="timeRange" is-range :picker-options="timePickerOptions" placeholder="选择默认值"></el-time-picker>
      </div>
      <!-- 任意时间+固定值时间范围默认值 -->
      <!-- 固定时间+固定时间间隔+固定值默认值 -->
      <div v-if="typeFixed && defaultTypeFixed && isFixedStep && pickerShow">
        <el-time-select v-model="curInput.time.time_default.fixed_value" :picker-options="timeSelectOptions" placeholder="选择默认值"></el-time-select>
      </div>
      <!-- 固定时间+固定时间间隔+固定值默认值 -->
      <!-- 固定时间+自定时间选项+固定值默认值 -->
      <div v-if="typeFixed && defaultTypeFixed && !isFixedStep">
        <el-select v-model="curInput.time.time_default.fixed_value" placeholder="请选择默认时间" class="h-40 w-200">
          <el-option v-for="item in curInput.time.time_config" :label="parseTime(item.value)" :value="item.value"></el-option>
        </el-select>
      </div>
      <!-- 固定时间+自定时间选项+固定值默认值 -->
    </el-form-item>
    <el-form-item label="时间选项" v-show="typeFixed && !isFixedStep">
      <div v-for="(item, index) in curInput.time.time_config">
        <el-time-picker class="m-b-10" v-model="item.value" format="HH:mm" placeholder="选项值"></el-time-picker>
        <!-- <el-input v-model.trim="item.value" placeholder="选项值" class="h-40 w-160"></el-input> -->
        <el-button size="small" type="danger" @click="deleteConfig(index)">删除</el-button>
      </div>
      <div>
        <el-button type="primary" @click="addConfig()">添加</el-button>
      </div>
    </el-form-item>
    <div class="form-tips">变量公式说明：h代表时，m代表分，s代表秒，+1代表往前加一个单位，-1代表往后减一个单位；使用&进行多公式连接。例：h+1代表一个小时后，m+10代表十分钟后，s+30代表30秒后，支持小数</div>
    <div class="h-28"></div>
  </el-form>
</template>

<script>
  import modelConfig from '../../../config/modelConfig'
  export default {
    props: ['curInput'],
    data() {
      return {
        rules: {
          time_step: [
            { validator: this.checkTimestep, trigger: 'blur' }
          ]
        },
        curDateType: 'date',
        format: '',
        pickerShow: true, // 用于控制时间控件类型转换
        timeSelectOptions: {
          start: '',
          step: '',
          end: ''
        },
        timePickerOptions: {
          selectableRange: '18:30:00 - 20:30:00'
        },
        timeType: [
          { id: 10, name: '固定时间' },
          { id: 20, name: '任意时间' }
        ],
        limitType: [
          { id: 10, name: '不限' },
          { id: 20, name: '变量公式' },
          { id: 30, name: '固定值' }
        ],
        defaultType: [
          { id: 10, name: '空' },
          { id: 20, name: '变量公式' },
          { id: 30, name: '固定值' }
        ],
        inputChange: false,
        timeRange: []
      }
    },
    mixins: [modelConfig],
    created() {
      this.setFormat()
    },
    methods: {
      addConfig() { // 添加配置
        this.curInput.time.time_config.push({ value: '' })
      },
      deleteConfig(index) { // 删除配置
        this.curInput.time.time_config.splice(index, 1)
      },
      resetInput(func) {
        this.pickerShow = false
        func()
        setTimeout(() => {
          this.pickerShow = true
        }, 1)
      },
      resetDefault() {
        this.curInput.time.time_default.single = ''
        this.curInput.time.time_default.range_start = ''
        this.curInput.time.time_default.range_end = ''
      },
      setTimeSelectOptions() {
        let timeMin = moment(this.curInput.time.time_min.fixed_value).format('HH:mm')
        let timeStep = this.curInput.time.time_step
        let timeMax = moment(this.curInput.time.time_max.fixed_value).format('HH:mm')
        if (!timeMin || !this.vaildTime(timeMin, 'm')) {
          this.timeSelectOptions.start = '00:00'
        } else {
          this.timeSelectOptions.start = timeMin
        }
        if (!timeStep || !this.vaildTime(timeStep, 'm')) {
          this.timeSelectOptions.step = '00:01'
        } else {
          this.timeSelectOptions.step = timeStep
        }
        if (!timeMax || !this.vaildTime(timeMax, 'm')) {
          this.timeSelectOptions.end = '23:59'
        } else {
          this.timeSelectOptions.end = timeMax
        }
      },
      setTimePickerOptions() {
        this.timePickerOptions.selectableRange = ''
        let minTime = moment(this.curInput.time.time_min.fixed_value).format('HH:mm:ss')
        let maxTime = moment(this.curInput.time.time_max.fixed_value).format('HH:mm:ss')
        if (!minTime || !this.vaildTime(minTime, 's')) {
          this.timePickerOptions.selectableRange += '00:00:00 - '
        } else {
          this.timePickerOptions.selectableRange += minTime + ' - '
        }
        if (!maxTime || !this.vaildTime(maxTime, 's')) {
          this.timePickerOptions.selectableRange += '23:59:00'
        } else {
          this.timePickerOptions.selectableRange += maxTime
        }
      },
      setFormat() {
        this.resetInput(() => {
          this.format = ''
          if (this.curInput.time.select_type == this.TIME_FIXED && this.curInput.time.fixed_step == 1) {
            this.format = 'HH:mm'
          }
          this.setTimeSelectOptions()
        })
      },
      vaildTime(value, unit) {
        if (unit == 'm') {
          // 验证格式：00:00
          return (/^\d{2}\:\d{2}$/).test(value)
        } else if (unit == 's') {
          // 验证格式：00:00:00
          return (/^\d{2}\:\d{2}\:\d{2}$/).test(value)
        }
      },
      checkTimestep(rule, value, callback) {
        if (!this.vaildTime(value, 'm')) {
          callback(new Error('请输入正确的时间间隔格式'))
        } else {
          callback()
        }
      },
      setInputChange(value) {
        this.inputChange = value
      },
      parseTime(value) {
        return moment(value).format('HH:mm')
      }
    },
    watch: {
      'curInput'() {
        this.setInputChange(true)
        if (this.curInput.time.range_status == 1 && this.curInput.time.time_default.fixed_value) {
          this.timeRange = []
          let timeRange = this.curInput.time.time_default.fixed_value.split(' to ')
          _(timeRange).forEach((res) => {
            this.timeRange.push(new Date(res))
          })
        }
      },
      'curInput.time.time_default.default_type'() {
        // 默认值类型变化
        if (this.inputChange) {
          return
        }
        this.resetDefault()
      },
      'curInput.time.range_status'() {
        // 是否选择范围变化
        if (this.inputChange) {
          return
        }
        this.resetInput(() => {
          this.resetDefault()
        })
        this.curInput.time.time_default.fixed_value = ''
      },
      'curInput.time.time_min.fixed_value'() {
        // 可选最小值固定值变化
        if (this.curInput.time.select_type == this.TIME_FIXED) {
          this.setTimeSelectOptions()
        } else if (this.curInput.time.select_type == this.TIME_ANYTIME) {
          this.setTimePickerOptions()
        }
      },
      'curInput.time.time_max.fixed_value'() {
        // 可选最大值固定值变化
        if (this.curInput.time.select_type == this.TIME_FIXED) {
          this.setTimeSelectOptions()
        } else if (this.curInput.time.select_type == this.TIME_ANYTIME) {
          this.setTimePickerOptions()
        }
      },
      'curInput.time.fixed_step'() {
        // 是否固定时间间隔改变
        this.setTimeSelectOptions()
        if (this.inputChange) {
          return
        }
        this.curInput.time.time_default.fixed_value = ''
        this.curInput.time.time_default.range_start = ''
        this.curInput.time.time_default.range_end = ''
      },
      'curInput.time.select_type'() {
        // 时间类型变化
        this.resetInput(() => {
          this.format = ''
          if (this.curInput.time.select_type == this.TIME_FIXED) {
            this.curInput.time.range_status = 0
            this.format = 'HH:mm'
          } else if (this.curInput.time.select_type == this.TIME_ANYTIME) {
          }
          if (this.inputChange) {
            return
          }
          this.curInput.time.range_status = 0
          this.curInput.time.time_min.fixed_value = ''
          this.curInput.time.time_max.fixed_value = ''
          console.log(this.curInput.time.select_type, this.TIME_FIXED, this.curInput.time.fixed_step, this.curInput.time.time_default.default_type, this.TIME_DEFAULT_VAR)
          if (this.curInput.time.select_type == this.TIME_FIXED &&
            this.curInput.time.fixed_step == 0 &&
            this.curInput.time.time_default.default_type == this.TIME_DEFAULT_VAR) {
            this.curInput.time.time_default.default_type = this.TIME_DEFAULT_NULL
          }
        })
      },
      'timeRange'() {
        let timeRange = []
        _(this.timeRange).forEach((res) => {
          timeRange.push(moment(res).format('YYYY-MM-DD HH:mm:ss'))
        })
        this.curInput.time.time_default.fixed_value = timeRange.join(' to ')
      },
      'inputChange'() {
        if (this.inputChange) {
          this.setInputChange(false)
        }
      }
    },
    computed: {
      typeFixed() {  // 类型是固定时间
        return this.curInput.time.select_type == this.TIME_FIXED
      },
      typeAnyTime() { // 类型是任意时间
        return this.curInput.time.select_type == this.TIME_ANYTIME
      },
      isFixedStep() { // 类型是固定时间，且固定间隔
        return this.curInput.time.fixed_step == 1
      },
      minTypeVar() { // 最小值类型是公式
        return this.curInput.time.time_min.type == this.DATE_LIMIT_VAR
      },
      minTypeFixed() { // 最小值类型是固定值
        return this.curInput.time.time_min.type == this.DATE_LIMIT_FIXED
      },
      maxTypeVar() { // 最大值类型是公式
        return this.curInput.time.time_max.type == this.DATE_LIMIT_VAR
      },
      maxTypeFixed() { // 最大值类型是固定值
        return this.curInput.time.time_max.type == this.DATE_LIMIT_FIXED
      },
      defaultTypeVar() { // 默认值类型为变量
        return this.curInput.time.time_default.default_type == this.TIME_DEFAULT_VAR
      },
      defaultTypeFixed() { // 默认值类型为固定值
        return this.curInput.time.time_default.default_type == this.TIME_DEFAULT_FIXED
      },
      isRange() { // 时间类型为范围
        return this.curInput.time.range_status == 1
      }
    }
  }
</script>


// WEBPACK FOOTER //
// timeConfig.vue?647034c6